// extracted by mini-css-extract-plugin
export var container = "style-module--container--8a109";
export var form = "style-module--form--0a195";
export var reg = "style-module--reg--b62bf";